import React from 'react'
import PropTypes from 'prop-types'
import { getRelativeServiceBasePath } from '../../../global/environments/path'

function Submitted({ name, email }) {
  return (
    <div className="u-textCenter u-marginTop6gu">
      <p className="u-marginBottom4gu">
        {name ? <>Welcome, {name}!</> : <>Welcome!</>}
      </p>
      <p className="u-marginBottom6gu">
        We&rsquo;re directing you to the subscription center
        {name ? (
          <>
            {' '}
            for <strong>{email}</strong>
          </>
        ) : (
          <>.</>
        )}
      </p>
      <img
        src={
          getRelativeServiceBasePath() +
          `/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`
        }
        alt="Loading..."
      />
    </div>
  )
}

Submitted.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
}

export default Submitted
